import type { ReactNode } from 'react';

import { SectionPanel } from './section-panel';

/** The bottom of a settings tab: what cannot be taken back, apart from everything else. */
export const DangerZone = ({ note, children }: { note?: string; children: ReactNode }) => (
  <SectionPanel title="Danger zone" note={note ?? 'cannot be undone'} tone="danger">
    {children}
  </SectionPanel>
);

interface IDangerActionProps {
  title: string;
  children: ReactNode;
  action: ReactNode;
  /** Why the action is off, said on the row: a greyed red button alone reads as broken. */
  blocked?: string | null;
}

export const DangerAction = ({ title, children, action, blocked }: IDangerActionProps) => (
  <div className="flex items-center gap-6 border-t border-border-sunken px-card py-4 first:border-t-0">
    <div className="min-w-0 flex-1">
      <p className="text-data font-medium text-primary">{title}</p>
      <div className="mt-1 max-w-prose-line text-meta leading-18 text-muted">{children}</div>
      {blocked && <p className="mt-1 text-meta leading-18 text-primary">{blocked}</p>}
    </div>
    <div className="shrink-0">{action}</div>
  </div>
);
